module.exports = __webpack_public_path__ + "img/twitter-icon-white.0748bc97.svg";